import { Injectable } from '@angular/core';
import {AppSettings} from '../../app.settings';
import {Dictionary} from 'highcharts';
import {Restangular} from 'ngx-restangular';
import { Partner } from '../partners/partners.service';

export interface Vendor {
  id: string;
  vendorSlug: string;
  config: Dictionary<any>;
  metadata: Dictionary<any>;
  schedules: Dictionary<any>;
}

@Injectable({
  providedIn: 'root'
})

export class VendorsService {

  constructor(
    private restangular: Restangular,
  ) {
  }

  createVendor(vendorData: Record<string, any>): Promise<Vendor> {
    return this.restangular.one('vendors').customPOST(vendorData).toPromise() as Promise<Vendor>;
  }

  deleteVendor(vendorId: string): Promise<Vendor> {
    return this.restangular.one('vendors', vendorId).customDELETE().toPromise() as Promise<Vendor>;
  }

  getAllVendors(): Promise<Vendor[]> {
    return this.restangular.one('vendors').getList().toPromise() as Promise<Vendor[]>;
  }

  updateVendor(vendorId: string, vendorData: Record<string, any>): Promise<Vendor[]> {
    return this.restangular.one('vendors', vendorId).customPUT(vendorData).toPromise() as Promise<Vendor[]>;
  }
}
